var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{staticClass:"masked-image",attrs:{"src":require("@/assets/analysis2.png"),"alt":"Image with Blue Mask"}})])
}]

export { render, staticRenderFns }